"use client";

import { ReactElement } from "react";
import Cookies from "js-cookie";
import { Locale } from "@/lib/server/get-dictionary";
import Hero from "../Common/Hero";
import ImageBanner from "../Common/ImageBanner";
import SignInButton from "../Common/SignInButton";
import GridLayout from "@/components/Common/GridLayout/GridLayout";
import { Sanitize } from "@/lib/sanitize/Sanitize";
import { AEA_PLUGIN_PRESENT_COOKIE_KEY } from "@/lib/constants/awsm";
import FederatedSignInButton from "../Common/FederateSignInButton";

interface UnauthProfileProps {
  lang?: Locale;
  currentPage?: string;
  translations: Record<string, string>;
}

export default function UnauthProfile({
  translations,
}: UnauthProfileProps): ReactElement {
  const aeaPluginPresent = !!Cookies.get(AEA_PLUGIN_PRESENT_COOKIE_KEY);

  return (
    <>
      <Hero
        title={translations.signInTo}
        description={<Sanitize html={translations.unAuthSub} />}
        action={
          aeaPluginPresent ? (
            <FederatedSignInButton
              buttonText={translations.signinToProfileButton}
              data-testid="signInButton"
            />
          ) : (
            <SignInButton
              buttonText={translations.signinToProfileButton}
              data-testid="signInButton"
            />
          )
        }
      />
      <GridLayout gridCols="grid-cols-1">
        <ImageBanner
          src="/profile/AWS_Illustration_RGB_Flat_Data-AIML.jpeg"
          alt="profile-illustration"
        />
      </GridLayout>
    </>
  );
}
